import React from "react";
import { useTranslation } from "react-i18next";

export default function AlarmDetailsModal({ alarm, formData, onClose }) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-[480px] max-h-[80vh] overflow-y-auto">
        <h2 className="text-xl font-semibold mb-4">{t(alarm.title)} {t('alarms.details')}</h2>

        <div className="space-y-4">
          {alarm.fields.map((f) => (
            <div key={f.key} className="flex items-center gap-3">
              <label className="w-1/3 font-medium">{t(f.label)}</label>
              <div className="flex-1 px-2 py-1 border rounded bg-gray-100 text-gray-700">
                {formData[f.key] ?? "-"}
              </div>

            </div>
          ))}
        </div>

        <div className="flex justify-end mt-6">
          <button
            className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
            onClick={onClose}
          >
            {t('alarms.close')}
          </button>
        </div>
      </div>
    </div>
  );
}
